import { createSelector } from '@reduxjs/toolkit'
import { RootState } from '../types'

const selectOverlayPreloader = (state: RootState) => state.overlayPreloader
export const selectOverlayPreloaderIsShow = createSelector(
  selectOverlayPreloader,
  (state) => state.isShow
)
